import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { useEffect, useState } from 'react';
import { Arrow } from '../../../../Common/Icon';
import { SubCategoryRow } from './SubCategoryRow';

import styles from './index.module.scss';
import {
  CategoryByIdData,
  CategoryByIdSubCategory,
} from '../../../../../store/category/byId';
import Loading from '../../../../Common/Loading';

interface CategoryDetailsProps {
  category: CategoryByIdData | null;
  subCategoryIdActive: string | null;
  theme?: 'light' | 'dark';
  howCategoryLink?: boolean;
  setSubCategory: (subCategory: CategoryByIdSubCategory | null) => void;
}

function CategoryDetails({
  category,
  subCategoryIdActive,
  theme = 'dark',
  howCategoryLink = true,
  setSubCategory,
}: CategoryDetailsProps) {
  const [showNoData, setShowNoData] = useState(false);

  // if (!category) {
  //   return <Loading style={{ minHeight: '100px' }} />;
  // }

  /** If there's no category - show loading up to 7 seconds.
   * If still not present after 7 sec - show 'No data' message */
  useEffect(() => {
    if (!category) {
      const timeout = setTimeout(() => {
        setShowNoData(true); // show message if data not arrived during timeout
      }, 7000);

      return () => clearTimeout(timeout); // cleanup if unmounted or category loads
    }
    setShowNoData(false); // reset if category arrives

    return undefined;
  }, [category]);

  if (!category && !showNoData) {
    return <Loading style={{ minHeight: '100px' }} />;
  }

  if (!category || showNoData) {
    return <div />;
  }

  return (
    <div className={clsx(styles.wrapper, styles[theme])}>
      <div className={styles.header}>
        {howCategoryLink ? (
          <Link
            to={`/categories/${category.id}`}
            className={styles.viewCategory}
          >
            View Category{' '}
            <Arrow
              className={styles.icon}
              width={24}
              height={24}
              viewBox="0 0 24 24"
            />
          </Link>
        ) : (
          <div />
        )}

        {category.subCategories.length > 0 ? (
          <div className={styles.theadWrapper}>
            <div className={styles.thead}>Customer Avg:</div>
            <div className={styles.thead}>Worker Avg:</div>
          </div>
        ) : null}
      </div>
      {category.subCategories.length > 0 ? (
        <div>
          {category?.subCategories.map((item) => (
            <SubCategoryRow
              key={item.id}
              subCategory={item}
              subCategoryIdActive={subCategoryIdActive}
              categoryId={category.id}
              setSubCategory={setSubCategory}
              displayMode="percent"
              theme={theme}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default CategoryDetails;
